import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import CircleIcon from '@mui/icons-material/Circle';
import { COLORS } from '../styles';

// Demo role tasks for the inbound. In a real build these come from the
// dispatcher assignment for this specific driver/aircraft.
const ROLE_TASKS = [
  'Chock the main gear',
  'Pull up the rear belt loader',
];

function AtGateScreen({ inboundGate, onConfirmArrived }) {
  return (
    <Box sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography sx={{ fontSize: '0.65rem', color: COLORS.textMuted, textTransform: 'uppercase', letterSpacing: 0.6 }}>
        Heading to Inbound
      </Typography>
      <Typography sx={{ fontSize: '1.5rem', color: COLORS.textPrimary, fontWeight: 700, lineHeight: 1.1, mt: 0.25 }}>
        Gate {inboundGate || '—'}
      </Typography>

      {/* Geofence radar */}
      <Box sx={{
        mt: 6,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1.5,
      }}>
        <Box sx={{ position: 'relative', width: 100, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {[0, 1, 2].map(i => (
            <Box key={i} sx={{
              position: 'absolute',
              width: 100, height: 100,
              borderRadius: '50%',
              border: `2px solid ${COLORS.accent}`,
              animation: `pingDot 2s ease-out ${i * 0.5}s infinite`,
              '@keyframes pingDot': {
                '0%': { opacity: 0.7, transform: 'scale(0.4)' },
                '100%': { opacity: 0, transform: 'scale(1.6)' },
              },
            }} />
          ))}
          <Box sx={{
            width: 50, height: 50, borderRadius: '50%',
            backgroundColor: COLORS.accent,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: `0 0 24px ${COLORS.accent}`,
          }}>
            <LocationOnIcon sx={{ color: '#0a1020', fontSize: 28 }} />
          </Box>
        </Box>

        <Typography sx={{ fontSize: '0.85rem', color: COLORS.textPrimary, textAlign: 'center', fontWeight: 600 }}>
          Drive to gate {inboundGate || '?'}
        </Typography>
        <Typography sx={{ fontSize: '0.7rem', color: COLORS.textMuted, textAlign: 'center', maxWidth: 240, lineHeight: 1.4 }}>
          Tap below when you're at the gate and ready to accept the flight.
        </Typography>
      </Box>

      {/* Role / tasks for this inbound */}
      <Box sx={{
        mt: 3,
        backgroundColor: 'rgba(251, 191, 36, 0.08)',
        border: `1px solid ${COLORS.warn}`,
        borderRadius: 1.5,
        p: 1.25,
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, mb: 0.75 }}>
          <AssignmentLateIcon sx={{ color: COLORS.warn, fontSize: 14 }} />
          <Typography sx={{
            fontSize: '0.6rem',
            color: COLORS.warn,
            textTransform: 'uppercase',
            letterSpacing: 0.7,
            fontWeight: 700,
          }}>
            Your Role on Aircraft Arrival
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          {ROLE_TASKS.map((task, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
              <CircleIcon sx={{ fontSize: 6, color: COLORS.warn }} />
              <Typography sx={{ fontSize: '0.78rem', color: COLORS.textPrimary }}>
                {task}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>

      <Button
        onClick={onConfirmArrived}
        sx={{
          mt: 3,
          backgroundColor: COLORS.success,
          color: '#0a1020',
          fontWeight: 700,
          py: 1.5,
          fontSize: '0.9rem',
          '&:hover': { backgroundColor: '#16a34a' },
        }}
      >
        ✓ I'M AT THE GATE
      </Button>
    </Box>
  );
}

export default AtGateScreen;
